export default __webpack_public_path__ + "static/media/test-group.a2022007.png";